export {};

let paypalLoadPromise: Promise<void> | null = null;

function selectOnlyPaymentMethod(): void {
    const paymentMethods = app.html.qAll('input[name="paymentMethod"]') as HTMLInputElement[];

    if (paymentMethods.length !== 1) {
        return;
    }

    const paymentMethod = paymentMethods[0];
    paymentMethod.checked = true;
}

document.addEventListener("started-guest", () => {
    document.location.href = '/';
});

document.addEventListener("started-user", () => {
    if (app.user.user?.isSubscribed) {
        document.location.href = config.routes.activation_success;
        return;
    }

    selectOnlyPaymentMethod();

    // Initialize PayPal while the user is loaded, so the button is ready even
    // after returning to this page with the browser's Back button.
    if (app.html.q('input[name="paymentMethod"][value="paypal"]')) {
        ensurePaypalLoaded();
    }
});

function isPaypal(event: Event): void {
    if (!window.app) {
        return;
    }

    const target = event.target as HTMLInputElement;
    const selectedPaymentMethod = target.value;

    if (selectedPaymentMethod === "paypal") {
        ensurePaypalLoaded();

        // Show paypal button
        app.html.hide('#submit-btn');
        app.html.show('#paypal-button-container');
    } else {
        // Hide paypal button
        app.html.show('#submit-btn', 'flex');
        app.html.hide('#paypal-button-container');
    }
}

function ensurePaypalLoaded(): Promise<void> {
    if (!paypalLoadPromise) {
        paypalLoadPromise = paypalInit()
            .catch((error) => {
                paypalLoadPromise = null;
                console.error('Failed to initialize PayPal buttons', error);
            });
    }

    return paypalLoadPromise;
}

function selectPaymentType(event: Event): void {
    event.preventDefault();

    if (!window.app) {
        return;
    }

    const form = event.target as HTMLFormElement;

    app.voyoForms.submit(form,
        async (data) => {
            const termsAgreed = data.generalTerms === "on";
            const paymentMethod = data.paymentMethod;

            if (!termsAgreed || !paymentMethod) {
                return;
            }
            
            if (paymentMethod === "sms") {
                document.location.href = config.routes.activation_sms;
            } else if (paymentMethod === "card") {
                document.location.href = config.routes.activation_credit_card_monthly;
            }
            return;
        }
    );
}

async function paypalInit(): Promise<void> {
    const planId = config.paypalPlanId;
    const userId = app.user.user ? app.user.user.id : null;
    if (!userId || !planId) {
        throw new Error('Missing user or PayPal plan ID');
    }

    await paypal.Buttons({
        createSubscription: (_: any, actions: any) => {
            return actions.subscription.create({
                'plan_id': config.paypalPlanId,
                'custom_id': userId.toString()
              });
        },
        onInit: (_: any, actions: any) => {
            actions.disable();

            const checkbox = document.querySelector('#general-terms__input') as HTMLInputElement;
            if (checkbox) {
                const syncTerms = () => {
                    if (checkbox.checked) {
                        actions.enable();
                    } else {
                        actions.disable();
                    }
                };

                checkbox.addEventListener('change', syncTerms);
                syncTerms();
            }
        },
        onApprove: (data: any) => {
            document.location.href = `${config.routes.activation_paypal}?type=return&id=${data.subscriptionID}`;
        },
        onCancel: () => {
            document.location.href = `${config.routes.activation_paypal}?type=cancel`;
        },
        onError: () => {
            document.location.href = '/';
        },
        style: {
            shape:  'rect',
            label:  'pay',
            tagline: false
        },
        fundingSource: paypal.FUNDING.PAYPAL
    }).render('#paypal-button-container');
}

window.isPaypal = isPaypal;
window.selectPaymentType = selectPaymentType;
